import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { hapticFeedback } from '../../../utils/telegram';
import './LanguageSelector.css';

const LanguageSelector = ({ className = '' }) => {
  const { language, changeLanguage, loading, availableLanguages, t } = useLanguage();

  const handleLanguageChange = async (newLanguage) => {
    if (newLanguage === language || loading) return;
    
    hapticFeedback.light();
    await changeLanguage(newLanguage);
  };

  return (
    <div className={`language-selector ${className}`}>
      <div className="language-selector-label">
        {t('language')}
      </div>
      <div className="language-options">
        {availableLanguages.map((lang) => (
          <button
            key={lang.code}
            className={`language-option ${language === lang.code ? 'active' : ''} ${loading ? 'disabled' : ''}`}
            onClick={() => handleLanguageChange(lang.code)}
            disabled={loading}
          >
            {lang.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector; 